export function equalAndTo(base: string, to = '') {
  return (item: { [x: string]: any }, key: string | number) => {
    const value = item[key];

    if (value === base) {
      return to;
    }
    return item[key];
  };
}